'use client';

import React, { useState } from 'react';

import PropertyCard, { PropertyCardData } from '@/components/PropertyCard';
import { Grid3X3, List, ChevronLeft, ChevronRight } from 'lucide-react';
import type { SearchFilters } from './PropertySearchClient';

// Backend integration point: GET /api/properties?filters=...
const MOCK_SEARCH_RESULTS: PropertyCardData[] = [
{
  id: 'sr-001',
  title: 'Kadıköy Moda\'da Deniz Manzaralı Lüks 3+1',
  price: '₺12.750.000',
  pricePerM2: '₺85.000',
  location: 'Moda Cad. No:42',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 150,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10ed2073c-1779341204936.png",
  imageAlt: 'Aydınlık salon, modern mutfak, deniz manzaralı pencereler',
  badges: ['one-cikan', 'dogrulanmis', '3d'],
  views: 4821,
  daysListed: 3,
  rentalYield: '5.8',
  investmentScore: 82
},
{
  id: 'sr-002',
  title: 'Fenerbahçe\'de Yeni Bina 3+1 Daire',
  price: '₺8.900.000',
  pricePerM2: '₺65.925',
  location: 'Fenerbahçe Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 135,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be989a4f-1773164988183.png",
  imageAlt: 'Modern daire salonu, yüksek tavan, parke zemin',
  badges: ['yeni', 'dogrulanmis'],
  views: 2156,
  daysListed: 1,
  rentalYield: '6.1',
  investmentScore: 79
},
{
  id: 'sr-003',
  title: 'Bağdat Cad. 3+1 Rezidans Daire',
  price: '₺10.200.000',
  pricePerM2: '₺62.962',
  location: 'Bağdat Cad. No:218',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 162,
  type: 'Rezidans',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17efc6ebc-1773268075370.png",
  imageAlt: 'Rezidans daire, modern dekorasyon, balkon manzarası',
  badges: ['one-cikan', '3d', 'video'],
  views: 3890,
  daysListed: 5,
  rentalYield: '5.5',
  investmentScore: 76
},
{
  id: 'sr-004',
  title: 'Göztepe\'de Bahçeli 4+1 Müstakil Ev',
  price: '₺15.500.000',
  pricePerM2: '₺77.500',
  location: 'Göztepe Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 4,
  bathrooms: 3,
  area: 200,
  type: 'Müstakil Ev',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dffcf728-1764673108848.png",
  imageAlt: 'Müstakil ev, geniş bahçe, çiçekler, özel garaj',
  badges: ['dogrulanmis'],
  views: 1742,
  daysListed: 18,
  rentalYield: '4.8',
  investmentScore: 68
},
{
  id: 'sr-005',
  title: 'Suadiye\'de Denize Yakın 2+1 Daire',
  price: '₺7.200.000',
  pricePerM2: '₺80.000',
  location: 'Suadiye Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 2,
  bathrooms: 1,
  area: 90,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae964f09-1784904412567.png",
  imageAlt: 'Daire iç mekanı, aydınlık salon, deniz manzarası',
  badges: ['fiyat-dustu'],
  views: 2934,
  daysListed: 22,
  rentalYield: '6.4',
  investmentScore: 84
},
{
  id: 'sr-006',
  title: 'Erenköy\'de Site İçi 3+1 Daire',
  price: '₺9.450.000',
  pricePerM2: '₺67.500',
  location: 'Erenköy Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 140,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://images.unsplash.com/photo-1687771774267-6319677a0994",
  imageAlt: 'Site içi daire, havuz manzarası, modern iç dekorasyon',
  badges: ['dogrulanmis', 'video'],
  views: 1580,
  daysListed: 9,
  rentalYield: '5.9',
  investmentScore: 73
},
{
  id: 'sr-007',
  title: 'Acıbadem\'de 1+1 Kiralık Daire',
  price: '₺28.000/ay',
  pricePerM2: '₺466/ay',
  location: 'Acıbadem Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 1,
  bathrooms: 1,
  area: 60,
  type: 'Daire',
  listingType: 'kiralik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15bd6f463-1783578910814.png",
  imageAlt: 'Küçük ama şık daire, modern mutfak, parke zemin',
  badges: ['yeni'],
  views: 892,
  daysListed: 0,
  investmentScore: 61
},
{
  id: 'sr-008',
  title: 'Caddebostan\'da Lüks 4+1 Daire',
  price: '₺18.900.000',
  pricePerM2: '₺94.500',
  location: 'Caddebostan Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 4,
  bathrooms: 3,
  area: 200,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b1ea193b-1772365137456.png",
  imageAlt: 'Lüks daire, deniz manzarası, geniş teras, modern iç tasarım',
  badges: ['one-cikan', '3d', 'dogrulanmis'],
  views: 6123,
  daysListed: 4,
  rentalYield: '4.5',
  investmentScore: 71
},
{
  id: 'sr-009',
  title: 'Kozyatağı\'nda 2+1 Yeni Proje Daire',
  price: '₺5.800.000',
  pricePerM2: '₺64.444',
  location: 'Kozyatağı Mah.',
  district: 'Kadıköy',
  city: 'İstanbul',
  bedrooms: 2,
  bathrooms: 1,
  area: 90,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c898e807-1764678678351.png",
  imageAlt: 'Yeni proje daire, açık mutfak konsepti, balkon',
  badges: ['yeni', 'video'],
  views: 1234,
  daysListed: 2,
  rentalYield: '6.8',
  investmentScore: 86
},
{
  id: 'sr-010',
  title: 'Ataşehir\'de 3+1 Otoparklı Rezidans',
  price: '₺7.650.000',
  pricePerM2: '₺58.846',
  location: 'Ataşehir Mah.',
  district: 'Ataşehir',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 130,
  type: 'Rezidans',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1946bc7a6-1776715357685.png",
  imageAlt: 'Rezidans kompleks, modern mimari, şehir manzarası',
  badges: ['dogrulanmis'],
  views: 2089,
  daysListed: 15,
  rentalYield: '6.2',
  investmentScore: 77
},
{
  id: 'sr-011',
  title: 'Ümraniye\'de 3+1 Kiralık Daire',
  price: '₺32.000/ay',
  pricePerM2: '₺266/ay',
  location: 'Ümraniye Mah.',
  district: 'Ümraniye',
  city: 'İstanbul',
  bedrooms: 3,
  bathrooms: 2,
  area: 120,
  type: 'Daire',
  listingType: 'kiralik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_174fdcc20-1772229037685.png",
  imageAlt: 'Ferah daire, geniş oturma odası, balkonlu',
  badges: ['fiyat-dustu'],
  views: 756,
  daysListed: 11,
  investmentScore: 58
},
{
  id: 'sr-012',
  title: 'Maltepe\'de 2+1 Deniz Manzaralı Daire',
  price: '₺6.400.000',
  pricePerM2: '₺71.111',
  location: 'Maltepe Sahil',
  district: 'Maltepe',
  city: 'İstanbul',
  bedrooms: 2,
  bathrooms: 1,
  area: 90,
  type: 'Daire',
  listingType: 'satilik',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1393df1c1-1774117898651.png",
  imageAlt: 'Sahil kenarı daire, deniz ve ada manzarası, ferah balkon',
  badges: ['yeni', 'dogrulanmis'],
  views: 3401,
  daysListed: 1,
  rentalYield: '7.1',
  investmentScore: 89
}];


const ITEMS_PER_PAGE_OPTIONS = [12, 24, 48];

interface SearchResultsProps {
  filters: SearchFilters;
  updateFilter: <K extends keyof SearchFilters>(key: K, value: SearchFilters[K]) => void;
  selectedPropertyId: string | null;
  onSelectProperty: (id: string | null) => void;
}

export default function SearchResults({ selectedPropertyId, onSelectProperty }: SearchResultsProps) {
  const [cardView, setCardView] = useState<'grid' | 'list'>('grid');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(12);

  const totalResults = 284;
  const totalPages = Math.ceil(totalResults / itemsPerPage);

  return (
    <div className="flex flex-col h-full">
      {/* Results Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-border bg-white sticky top-0 z-10">
        <div>
          <span className="text-sm font-bold text-foreground tabular-nums">
            {totalResults.toLocaleString('tr-TR')} ilan
          </span>
          <span className="text-xs text-muted-foreground ml-2">Kadıköy, İstanbul</span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setCardView('grid')}
            className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${cardView === 'grid' ? 'bg-primary-light text-primary' : 'text-muted-foreground hover:text-foreground'}`}>
            
            <Grid3X3 size={16} />
          </button>
          <button
            onClick={() => setCardView('list')}
            className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${cardView === 'list' ? 'bg-primary-light text-primary' : 'text-muted-foreground hover:text-foreground'}`}>
            
            <List size={16} />
          </button>
        </div>
      </div>

      {/* Results Grid */}
      <div className="flex-1 overflow-y-auto p-4">
        {cardView === 'grid' ?
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
            {MOCK_SEARCH_RESULTS.map((property) =>
          <div
            key={property.id}
            onClick={() => onSelectProperty(property.id === selectedPropertyId ? null : property.id)}
            className={`transition-all duration-150 ${selectedPropertyId === property.id ? 'ring-2 ring-primary rounded-2xl' : ''}`}>
            
                <PropertyCard property={property} variant="grid" />
              </div>
          )}
          </div> :

        <div className="space-y-3">
            {MOCK_SEARCH_RESULTS.map((property) =>
          <div
            key={property.id}
            onClick={() => onSelectProperty(property.id === selectedPropertyId ? null : property.id)}
            className={`transition-all duration-150 ${selectedPropertyId === property.id ? 'ring-2 ring-primary rounded-2xl' : ''}`}>
            
                <PropertyCard property={property} variant="list" />
              </div>
          )}
          </div>
        }

        {/* Empty state */}
        {MOCK_SEARCH_RESULTS.length === 0 &&
        <div className="flex flex-col items-center justify-center py-20 text-center">
            <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mb-4">
              <Grid3X3 size={28} className="text-muted-foreground" />
            </div>
            <h3 className="text-lg font-bold text-foreground mb-2">İlan bulunamadı</h3>
            <p className="text-muted-foreground text-sm max-w-xs">
              Arama kriterlerinizle eşleşen ilan yok. Filtreleri genişletmeyi deneyin.
            </p>
          </div>
        }
      </div>

      {/* Pagination */}
      <div className="px-4 py-3 border-t border-border bg-white flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span>Sayfa başına:</span>
          <select
            value={itemsPerPage}
            onChange={(e) => {setItemsPerPage(Number(e.target.value));setCurrentPage(1);}}
            className="border border-border rounded-lg px-2 py-1 text-sm font-medium text-foreground focus:outline-none focus:border-primary">
            
            {ITEMS_PER_PAGE_OPTIONS.map((n) =>
            <option key={`ipp-${n}`} value={n}>{n}</option>
            )}
          </select>
        </div>

        <div className="flex items-center gap-1">
          <button
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            className="w-8 h-8 rounded-lg border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-all">
            
            <ChevronLeft size={16} />
          </button>

          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            const page = i + 1;
            return (
              <button
                key={`page-${page}`}
                onClick={() => setCurrentPage(page)}
                className={`w-8 h-8 rounded-lg text-sm font-semibold transition-all ${currentPage === page ? 'bg-primary text-white' : 'border border-border text-foreground hover:bg-muted'}`}>
                
                {page}
              </button>);

          })}

          {totalPages > 5 &&
          <>
              <span className="text-muted-foreground px-1">...</span>
              <button
              onClick={() => setCurrentPage(totalPages)}
              className="w-8 h-8 rounded-lg text-sm font-semibold border border-border text-foreground hover:bg-muted transition-all">
              
                {totalPages}
              </button>
            </>
          }

          <button
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
            className="w-8 h-8 rounded-lg border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-all">
            
            <ChevronRight size={16} />
          </button>
        </div>

        <span className="text-xs text-muted-foreground tabular-nums">
          {(currentPage - 1) * itemsPerPage + 1}–{Math.min(currentPage * itemsPerPage, totalResults)} / {totalResults.toLocaleString('tr-TR')}
        </span>
      </div>
    </div>);

}